import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import { registerView } from "@frui.ts/views/dist";
import InternalTransferDetailViewModel from "viewModels/finance/bankExports/internalTransfers/internalTransferDetailViewModel";
import BankExportDetailView from "../bankExportDetailView";

const InternalTransferDetailView: ViewComponent<InternalTransferDetailViewModel> = observer(({ vm }) => {
  return <BankExportDetailView vm={vm} />;
});

registerView(InternalTransferDetailView, InternalTransferDetailViewModel);
